(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@lokidb/full-text-search", [], factory);
	else if(typeof exports === 'object')
		exports["@lokidb/full-text-search"] = factory();
	else
		root["@lokidb/full-text-search"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 